import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  userName: string;
  password: string;
  phone: string;
  lastName: string;
  firstName: string;
  PIN: string;
  helloPayPin: string;
}

const initialState: UserState = {
  userName: '',
  password: '',
  phone: '+36',
  lastName: '',
  firstName: '',
  PIN: '',
  helloPayPin: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserName: (state, action: PayloadAction<string>) => {
      state.userName = action.payload;
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setPIN: (state, action: PayloadAction<string>) => {
      state.PIN = action.payload;
    },
    setHelloPayPin: (state, action: PayloadAction<string>) => {
      state.helloPayPin = action.payload;
    },
  },
});

export const { setUserName, setPassword, setPhone, setLastName, setFirstName, setPIN, setHelloPayPin } = userSlice.actions;
export default userSlice.reducer;